import React from 'react';
import './UserOrdersTabMenu.css';
import { localized } from '../../../config/localization';
import { Routes } from '../../../app/Routes';
import { useNavigate } from 'react-router';

type Props = {
  readonly isCustomerFilterActive: boolean;
};

export function UserOrdersTabMenu({ isCustomerFilterActive }: Props) {
  const navigate = useNavigate();

  return (
    <div className="user-orders-tab-menu">
      <div className="user-orders-tab-menu__container">
        <div
          className={`user-orders-tab-menu__tab${isCustomerFilterActive ? ' user-orders-tab-menu__tab--active' : ''}`}
          onClick={() => {
            navigate(Routes.CUSTOMER_ORDERS);
          }}
        >
          {localized.PERSONAL}
        </div>
        <div
          className={`user-orders-tab-menu__tab${!isCustomerFilterActive ? ' user-orders-tab-menu__tab--active' : ''}`}
          onClick={() => {
            navigate({
              pathname: Routes.CUSTOMER_ORDERS,
              search: `?filter=customer`,
            });
          }}
        >
          {localized.OTHERS}
        </div>
      </div>
    </div>
  );
}
